import React, { useState, useEffect } from 'react';
import { Button, Checkbox, FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, TextField, Typography } from '@material-ui/core';
import { DateRange, DateRangePicker, LocalizationProvider } from '@material-ui/pickers';
import esLocale from "date-fns/locale/es";
import moment from 'moment';
import 'moment/locale/es'
import DateFnsUtils from '@date-io/date-fns';
import { ITransactionalReport } from '../../../interfaces/ITransactionalReport';
import Validations from '../../../helpers/Validations';
import './ReportFormResources.scss';
import DownloadModal from '../DownloadModal';
import ErrorModal from '../ErrorModal';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import LoadingLockPage from '../../ShareComponents/LoadingLockPage';

import { StateByRole } from '../../../interfaces/StateByRole';
import { IFilterResoruces, ReportResourceFilter } from '../../../interfaces/IFilterResources';
import { IGetNewEvent } from '../../../interfaces/IGetNewEvent';
import { getEventsNews } from '../../../services/NewsEventsService';
import { sortByKeyDesc } from '../../../helpers/sharedFunctions';
import { reportResources } from '../../../services/ReportsService';


const typeOptions: Array<StateByRole> = [
  { id: 1, label: 'Todos', value: 'Todos', description: '', permission: [] },
  { id: 4, label: 'Instructivo', value: 'Instructivo', description: '', permission: [] },
  { id: 5, label: 'Capacitación', value: 'Capacitacion', description: '', permission: [] },
]

const initialFormValues = {
  type: "Todos",
  resource: 0,
  dateInit: "",
  dateEnd: ""
}

const formValidations = {
  type: {
    error: '',
    validate: "textNumber",
    minLength: 1,
    required: true
  },
  resource: {
    error: '',
    validate: "textNumber",
    minLength: 3,
    required: true
  },
  dateInit: {
    error: '',
    validate: "textNumber",
    minLength: 3,
    required: true
  },
  dateEnd: {
    error: '',
    validate: "textNumber",
    minLength: 3,
    required: true
  },
}

const ReportFormResources = () => {
  const { promiseInProgress } = usePromiseTracker();

  const [formValuesReports, setFormValuesReports] = useState<IFilterResoruces>(new IFilterResoruces({}));
  const [formErrorsReport, setFormErrorsReport] = useState(initialFormValues);
  const [valueD, setValueD] = React.useState<DateRange<Date>>([null, null]);
  const [urlFileReportLog, setUrlFileReportLog] = useState<string>('');
  const [recordsfound, setRecordsFound] = useState<number>(0);
  const [openModalDownload, setOpenModalDownload] = React.useState(false);
  const [openModalError, setOpenModalError] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [data, setData] = useState<Array<IGetNewEvent>>([]);
  const [dataFiltered, setDataFiltered] = useState<Array<IGetNewEvent>>([]);

  const isValid = formValuesReports.resource && formValuesReports.resource != 0 && formValuesReports.type.length > 0 && formValuesReports.rangeDate.dateInit.length > 0 && formValuesReports.rangeDate.dateEnd.length > 0 &&
    formValuesReports.rangeDate.dateInit != "Fecha inválida" && formValuesReports.rangeDate.dateEnd != "Fecha inválida";


  const radioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target as HTMLInputElement;

    setFormValuesReports(prev => ({
      ...prev,
      resource: 0
    }));

    handleChange(event);
  };

  useEffect(() => {
    setDataFiltered([]);

    if (formValuesReports.type === 'Todos') {
      setDataFiltered(data);
    } else {
      const resourceObjSelected = data.filter(resource => resource.type === formValuesReports.type);
      if (resourceObjSelected) {
        setDataFiltered(resourceObjSelected);
      }
    }

  }, [formValuesReports.type]);


  useEffect(() => {
    if (valueD !== null) {
      const startDate: string = moment(valueD[0]).format('YYYY/MM/DD');
      const endDate: string = moment(valueD[1]).format('YYYY/MM/DD');
      setFormValuesReports(prev => ({
        ...prev,
        rangeDate: {
          dateInit: startDate,
          dateEnd: endDate
        }
      }));
    }
  }, [valueD]);

  useEffect(() => {
    const getInitialdata = async () => {
      const getInfo: any = await await trackPromise(getEventsNews({ type: ["Capacitacion", "Instructivo"] }));
      if (getInfo.status === 200) {
        let resultList = (await getInfo.json()).publishings;
        resultList = sortByKeyDesc(resultList, 'updatedAt');
        setData(resultList);
        setDataFiltered(resultList);
      } else {
        setOpenModalError(true);
        setErrorMessage("Hubo un error, intente de nuevo mas tarde, o contacte al administrador general");
      }

      setFormValuesReports(prev => ({
        ...prev,
        type: "Todos"
      }));

    }

    getInitialdata();
  }, []);


  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormValuesReports(prev => ({
      ...prev,
      [name]: value
    }));

    const error = Validations(name, value, formValidations) || "";

    setFormErrorsReport(prev => ({
      ...prev,
      [name]: error
    }));

  }

  useEffect(() => {
    if (valueD !== null) {
      const startDate: string = moment(valueD[0]).format('YYYY/MM/DD');
      const endDate: string = moment(valueD[1]).format('YYYY/MM/DD');
      setFormValuesReports(prev => ({
        ...prev,
        rangeDate: {
          dateInit: startDate,
          dateEnd: endDate
        }
      }));
    }
  }, [valueD])

  const makeReport = async () => {
    let reportFilter: ReportResourceFilter = new ReportResourceFilter();
    reportFilter.publishingId = formValuesReports.resource;
    reportFilter.rangeDate = formValuesReports.rangeDate;

    const response: any = await trackPromise(reportResources(reportFilter));

    if (response.status === 200) {
      const resultFile = (await response.json());
      setUrlFileReportLog(resultFile.urlFile);
      console.log(resultFile.url)
      setRecordsFound(resultFile.quantity);
      setOpenModalDownload(true);
    } else {
      setOpenModalError(true);
      setErrorMessage("Hubo un error, intente de nuevo mas tarde, o contacte al administrador general");
    }

  }

  const handleCloseModalDownload = () => {
    setOpenModalDownload(false);
    window.location.reload();
  };

  const handleCloseModalError = () => {
    setOpenModalError(false);
  };


  return (
    <>
      <Grid container className="main-container">
        <Grid container item xs={12} className="main-report-container">
          <Grid container item xs={12} className="report-container">
            <Grid container item xs={12} className="title-container-report">
              <Typography variant="h2" className="title">
                Seleccione filtros del reporte
              </Typography>
            </Grid>
            <Grid container className="report-content">
              <Grid item xs={12} md={6} xl={6} className="field-box-margin">
                <Typography variant="h5" className="field-box-title">Tipo de recurso*</Typography>
                <FormControl component="fieldset">
                  <RadioGroup row className="radio-container" aria-label="type" name="type" value={formValuesReports.type} onChange={radioChange}>
                    {typeOptions.map(option => (
                      <FormControlLabel key={option.id} value={option.value} className="radio-btn" control={<Radio className="color-btn" />} label={option.label} labelPlacement="start" />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Grid>

            </Grid>
            <Grid container className="report-content">
              <Grid item xs={12} md={6} xl={6} className="field-box-margin">
                <Typography variant="h5" className="field-box-title">Recurso*</Typography>
                <TextField
                  fullWidth
                  id="outlined-select-resource"
                  select
                  name="resource"
                  label={formValuesReports.resource === 0 ? "Seleccione" : ""}
                  value={
                    dataFiltered.find(opt => opt.id === formValuesReports.resource)
                      ? formValuesReports.resource
                      : ""}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: false }}
                  margin="none"
                  variant="outlined"
                >
                  {
                    dataFiltered.length > 0 ?
                      dataFiltered.map((option: IGetNewEvent) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))
                      :
                      <MenuItem value={formValuesReports.resource}></MenuItem>
                  }
                </TextField>
              </Grid>
            </Grid>

            <Grid container className="report-content">
              <Grid item xs={12} md={6} xl={4} className="field-box-margin">
                <Typography variant="h5" className="field-box-title">Rango de fechas*</Typography>
                <Grid container item xs={12}>
                  <LocalizationProvider dateAdapter={DateFnsUtils} locale={esLocale} >
                    <DateRangePicker
                      calendars={1}
                      PopperProps={{
                        placement: "bottom"
                      }}
                      value={valueD || null}
                      onChange={(valueD) => {
                        setValueD(valueD);
                      }}
                      renderInput={(startProps, endProps) => (
                        <Grid container item xs={12} alignItems="center">
                          <Grid item xs={12} sm={5}>
                            <TextField
                              {...startProps}
                              autoComplete="off"
                              fullWidth
                              name="dateInit"
                              margin="none"
                              label={valueD[0] !== null ? "" : "AAAA/MM/DD"}
                              error={!!formErrorsReport.dateInit}
                              helperText={formErrorsReport.dateInit}
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item xs={12} sm={2}>
                            <Typography variant="h5" className="field-box-title" style={{ textAlign: 'center' }}>
                              Hasta
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={5}>
                            <TextField
                              {...endProps}
                              fullWidth
                              autoComplete="off"
                              name="dateEnd"
                              margin="none"
                              label={valueD[1] !== null ? "" : "AAAA/MM/DD"}
                              error={!!formErrorsReport.dateEnd}
                              helperText={formErrorsReport.dateEnd}
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                            />
                          </Grid>
                        </Grid>
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>

            <LoadingLockPage load={promiseInProgress} />
          </Grid>
        </Grid>
        <Grid container item xs={12} className="button-download-report-container">
          <Button className="generate-report-btn" variant="contained" size="small" onClick={makeReport} disabled={!isValid}>
            <Typography variant="h5" className="regular-serif">Generar reporte</Typography>
          </Button>
        </Grid>
        <ErrorModal errorMsg={errorMessage} handleCloseModal={handleCloseModalError} openModalError={openModalError} />
        <DownloadModal downloadMsg={"El reporte se ha generado con éxito"} downloadMsg2="¿Desea descargarlo?" handleCloseModal={handleCloseModalDownload} openModalDownload={openModalDownload} urlReport={urlFileReportLog} total={recordsfound.toString()} />

      </Grid>
    </>
  )
}

export default ReportFormResources
